module.exports = __webpack_public_path__ + "img/spark_logo_black.a5e30ea4.svg";